// @ts-nocheck
import React, { Component } from 'react'
import Styles from './ExUsDetails.module.css'
import apiFetch from '../../api/apiFetch'
import Loading from '../../components/Loading/Loading'
import DetailsInformation from './components/Details_Information'
//import DetailsPriAddress from './components/Details_PriAddress';
import AddressAlignment from "./components/address-alignment/AddressAlignment";
import DetailsAffiliations from './components/Details_Affiliations'
import DetailsChangeRequests from './components/Details_ChangeRequests'
import DetailsEdit from './components/Details_Edit'
import AddressHistory from './components/Details_Address_History'
import AddExUsSuccess from './components/AddExUsSuccess'
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../../AppInsights';
import { withRouter } from '../../utility/withRouter'

class ExUsDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            spinning: false,
            addslnsuccess: false,
            editsubmitted: false,
            prof_id: this.props.match.params.PROF_ID,
            // section state: null = loading, [] = empty
            data: null,
            addresses: null,
            changeRequests: null,
            addressHistory: null
        };
    }
    addTo(index, i, added, addSpend) {
        let json = {}
        let id = this.state.data[0].PROF_ID;
        if (added) {
            if (i === 0) {
                json.REQUEST_TYPE = "EXUS Remove from - Spend";
            } else if (i === 1) {
                json.REQUEST_TYPE = "EXUS Remove from - CRM";
            } else if (i === 2) {
                json.REQUEST_TYPE = "EXUS Remove from - CTMS";
            }
        } else {
            if (i === 0) {
                json.REQUEST_TYPE = "EXUS Add to - Spend";
            } else if (i === 1) {
                json.REQUEST_TYPE = "EXUS Add to - CRM";
            } else if (i === 2) {
                json.REQUEST_TYPE = "EXUS Add to - CTMS";
            }
        }

       json.PROF_ID = id
        json.REQUESTOR_ID = this.props.user.email
        json.REQUESTOR_NAME = this.props.user.userName
        json.REQUESTOR_TEAM = this.props.user.team
        json.REQUESTOR_TERR = this.props.user.terr

        apiFetch('/api/v2/global/change-request', json).then(() => {
            if (addSpend) {
                let json = {}
                json.REQUEST_TYPE = "EXUS Add to - Spend";
                json.PROF_ID = id
                json.REQUESTOR_ID = this.props.user.email
                json.REQUESTOR_NAME = this.props.user.userName
                json.REQUESTOR_TEAM = this.props.user.team
                json.REQUESTOR_TERR = this.props.user.terr
                apiFetch('/api/v2/global/change-request', json)
            }
        })
    }

    
    closeEdit() {
        this.setState({ editScreen: undefined, addslnsuccess: true })
    }

   submitEdit(json, list) {
       // alert('submitEdit');
        if (this.state.editsubmitted === true) { return; }
        this.setState({ editsubmitted: true });
        if (!list) {
            json.PROF_ID = this.state.data[0].PROF_ID
            json.REQUESTOR_ID = this.props.user.email
            json.REQUESTOR_NAME = this.props.user.userName
            json.REQUESTOR_TEAM = this.props.user.team
            json.REQUESTOR_TERR = this.props.user.terr
        }
        apiFetch('/api/v2/global/change-request', json).then(() => {
            this.setState({ editsubmitted: false });
            this.closeEdit();

            //this.setChange(data);
        }).catch(() => {
            this.setState({ editsubmitted: false });
        })
    }

    editScreen(i, id) {

      //  console.log('here');

        this.setState({
            editScreen: <DetailsEdit
                editScreen={this.editScreen.bind(this)}
                //affiliations={this.state.affiliations}
                data={this.state.data}
                submit={this.submitEdit.bind(this)}
                //change={this.state.change}
                addresses={this.state.addresses}
                close={this.close.bind(this)}
                //id={id}
                index={i}
                user={this.props.user}
                //msl={this.state.msl}
                //setChange={this.setChange.bind(this)}
                //updateChanges={this.updateChanges.bind(this)}
            />
        })
    }


    componentDidMount() {

        this.loadChange();


    }

    loadChange() {
        const json = {
            PROF_ID: this.state.prof_id,
            TEAM: this.props.user.team
        };

        // Core resolves first — render header as soon as it arrives
        apiFetch('/api/v2/exus/core', json).then((core) => {
            if (!core || core.length === 0) return;
            this.setState({ data: core, loaded: true });
        });

        // Secondary sections fire in parallel
        apiFetch('/api/v2/exus/change-requests', json)
            .then(d => this.setState({ changeRequests: d ?? [] }));

        apiFetch('/api/v2/exus/address-history', json)
            .then(d => this.setState({ addressHistory: d ?? [] }));

        // Address sub-sections arrive as a group
        Promise.all([
            apiFetch('/api/v2/exus/primary-address',      json),
            apiFetch('/api/v2/exus/secondary-addresses',  json),
            apiFetch('/api/v2/exus/addresses',            json),
        ]).then(([pri, sec, addr]) => {
            this.setState({ addresses: [pri ?? [], sec ?? [], addr ?? []] });
        });
    }

    close() {
        this.setState({ editScreen: undefined })
    }
    closeSlnSuccess() {
        this.setState({ addslnsuccess: false });
    }
    render() {
        let successDialog = this.state.addslnsuccess ? (<AddExUsSuccess close={this.closeSlnSuccess.bind(this)} />) : ""

       if (this.state.loaded) {
        return (
            <div className={Styles.Details}>
                {this.state.editScreen ? this.state.editScreen : ""}
                <div className={Styles.TopBar}>
                    <div className={Styles.Back} onClick={() => {



                        //console.log(this.props.history.location.state);
                       // console.log(this.props.history.location.state.from);
                       
                     //   alert(this.props.history.location.state.from);
                        if (this.props.history.location.state != null && this.props.history.location.state.from === '/exus') {
                            //alert('1');
                            this.props.history.push({
                                pathname: '/exus',
                                state: {
                                    from: '/exus/details'
                                }
                            })
                        }
                        else {
                            //alert('2');
                            //if (document.referrer !== window.location.origin) {
                            //    window.location.href = "/";
                            //}
                            //else {
                                //alert('3');
                            this.props.history.go(-1);
                           //}
                        }
                    }}><span aria-hidden="true">‹</span>BACK TO SEARCH</div>
                </div>{successDialog}
                <div className={Styles.pageWrapper}>
                    <div className={Styles.Wrapper}>
                        {/*<DetailsInformation editScreen={this.editScreen.bind(this)} submitEdit={this.submitEdit.bind(this)} user={this.props.user} loadChange={this.loadChange.bind(this)} number={this.props.number} addresses={this.state.addresses} msl={this.state.msl} addTo={this.addTo.bind(this)} />*/}
                        {this.state.data && this.state.addresses
                            ? <DetailsInformation data={this.state.data} editScreen={this.editScreen.bind(this)} submitEdit={this.submitEdit.bind(this)} user={this.props.user} number={this.props.number} addTo={this.addTo.bind(this)} addresses={this.state.addresses} />
                            : <Loading />}
                    </div>
                    <div className={Styles.Wrapper}>
                        <AddressAlignment />
                    </div>
                    <div className={Styles.Wrapper}>
                        <AddressHistory addresses={this.state.addressHistory} />
                    </div>
                    <div className={Styles.Wrapper}>
                        <DetailsChangeRequests data={this.state.changeRequests}/>
                    </div>
                </div>
                
            </div>
        );
        }
        else {
            return (<Loading/>)
        }
    }
}

export default withAITracking(reactPlugin, withRouter(ExUsDetails));